export enum RepositoryLocationType {
  GDB = 'GDB',
  ONTOPIC = 'ONTOPIC',
  SPARQL = 'SPARQL'
}
